"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const _1 = require(".");
const ProductRecommendationFragment = (0, graphql_tag_1.default) `
  fragment product on Product {
    id
    adsSellerId
    variationId
    title
    description
    image
    available
    url
    path
    reference
    offerTags
    restrictions
    price {
      paymentMethodDescription
      price
      fullPrice
      bestPrice
      discount
      currency
    }
    installment {
      paymentMethodDescription
      quantity
      amount
      totalAmount
    }
    rating {
      count
      score
    }
    badges {
      text
      imageUrl
      container
      position
      tooltip
    }
    seller {
      ...seller
    }
    brand {
      ...brand
    }
    category {
      ...category
    }
    subcategory {
      ...subcategory
    }
    attributes {
      ...attributes
    }
  }
  ${_1.ProductWithSellerFragment}
  ${_1.ProductBrandFragment}
  ${_1.ProductCategoryFragment}
  ${_1.ProductSubCategoryFragment}
  ${_1.ProductAttributesFragment}
`;
exports.default = ProductRecommendationFragment;
